import React from "react"
import autobind from "class-autobind"
import { Card, Chip, Toggle, IconButton, FontIcon, TextField, MenuItem, SelectField } from "material-ui"
import _ from "lodash"
import { IEmployeeStatus, IGigPoolTierSettings } from "../../../models"
import * as api from "../../../api"
import AccountStore from "../../../stores/AccountStore"
import UserStatusDialog from "../../../pages/jobs/job-details/job-detail-worker-pool/worker-pool-detail/UserStatusDialog"
import AppStateStore from "../../../stores/AppStateStore"
import ChooseBadgeChip from "../../hr_settings/choose_badge/ChooseBadgeChip"

interface IProps {
    title: string
    gigPoolTierSettings: IGigPoolTierSettings
    updateGigPoolTierSetting(newSetting: IGigPoolTierSettings): void
    hideLimitBroadcastByProximityInMiles: boolean
}

interface IState {
    openStatusDialog: boolean
    employeeStatuses: IEmployeeStatus[]
    gigPoolTierSettings: IGigPoolTierSettings
    rewardType: number
    enabled: boolean
}

export default class GigPoolTierSettings extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            gigPoolTierSettings: props.gigPoolTierSettings ? props.gigPoolTierSettings : { EmployeeStatusList: [] } as IGigPoolTierSettings,
            openStatusDialog: false,
            employeeStatuses: [],
            rewardType: this.getRewardTypeEnumValue(props.gigPoolTierSettings),
            enabled: false
        }
        autobind(this)
    }

    componentWillReceiveProps(newProps) {
        this.setState({ gigPoolTierSettings: newProps.gigPoolTierSettings ? newProps.gigPoolTierSettings : { EmployeeStatusList: [] } as IGigPoolTierSettings })
    }

    componentDidMount() {
        this.getEmployeeStatuses()
    }

    getRewardTypeEnumValue(gigPoolTierSettings) {
        if (!gigPoolTierSettings || gigPoolTierSettings.RewardScheduledEmployeeBadgePoints) {
            return 0
        } else if (gigPoolTierSettings.RewardScheduledEmployeeAmount) {
            return 1
        } else if (gigPoolTierSettings.RewardScheduledEmployeeDifferential) {
            return 2
        }

        return -1
    }

    getEmployeeStatuses() {
        api.getEmployeeStatuses(AccountStore.getCurrentAccount().Id).then((response) => {
            this.setState({ employeeStatuses: response.data })
        })
    }

    handleRemoveEmployeeStatus = (Status) => {
        let changedSetting = _.cloneDeep(this.state.gigPoolTierSettings)
        const item = changedSetting.EmployeeStatusList.findIndex(
            (x) =>
                x.Id === Status.Id
        )

        if (item != -1) {
            changedSetting.EmployeeStatusList = _.remove(changedSetting.EmployeeStatusList, item);
            this.props.updateGigPoolTierSetting(changedSetting)
        }
    }

    handleEmployeeStatusAdd = ({ Status, SubStatus }) => {
        const isExist = this.state.gigPoolTierSettings.EmployeeStatusList.find((x) => x.Id === Status.Id && x.EmployeeSubStatus.Id == SubStatus.Id)
        if (!isExist) {
            let changedSetting = _.cloneDeep(this.state.gigPoolTierSettings)
            Status.EmployeeSubStatus = SubStatus
            Status.SubStatus = [SubStatus]
            changedSetting.EmployeeStatusList.push(Status)
            this.props.updateGigPoolTierSetting(changedSetting)
        } else {
            AppStateStore.setProgressSnackbarContent("Already Exists")
        }

        this.setState({ openStatusDialog: false })
    }

    render() {
        return (
            <Card style={{ marginBottom: 20 }}>
                <div style={{ display: "grid", gridTemplateColumns: "auto 100px", alignItems: "center", padding: 20, paddingBottom: 0, paddingTop: 0 }}>
                    <div style={{ gridColumn: 1, gridRow: "auto" }}>
                        <h4>{this.props.title}</h4>
                    </div>
                    <div style={{ gridColumn: 2, gridRow: "auto" }}>
                        <Toggle
                            toggled={this.state.gigPoolTierSettings.Enabled}
                            onToggle={(event, value) => {
                                this.state.gigPoolTierSettings.Enabled = value
                                this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings }, () => this.props.updateGigPoolTierSetting(this.state.gigPoolTierSettings))
                            }}
                            labelPosition="left"
                            label={"Enabled"}
                        />
                    </div>
                </div>

                {this.state.gigPoolTierSettings.Enabled &&
                    <div style={{ display: "grid", gridTemplateColumns: "60% 40%", alignItems: "center", padding: 20, paddingTop: 0 }}>                  
                        
                        <div style={{ gridColumn: 1, gridRow: "auto" }}>
                            <b style={{ marginRight: 10 }}>User Status List</b>
                        </div>
                        <div style={{ gridColumn: "span 2", gridRow: "auto", paddingBottom: 10 }}>
                            {this.state.gigPoolTierSettings.EmployeeStatusList &&
                                this.state.gigPoolTierSettings.EmployeeStatusList.map((employeeStatus, index) =>
                                    <Chip
                                        style={{ marginTop: 10, marginRight: 5, display: "inline-flex" }}
                                        onRequestDelete={() => { this.handleRemoveEmployeeStatus(employeeStatus as any) }}
                                        key={index}
                                    >
                                        {employeeStatus.EmployeeSubStatus && <span>{employeeStatus.Name}: {employeeStatus.EmployeeSubStatus.Name}</span>}
                                        {!employeeStatus.EmployeeSubStatus && <span>{employeeStatus.Name}</span>}
                                    </Chip>
                                )}

                            <IconButton
                                style={{ height: 33, display: "inline-flex" }}
                                onTouchTap={() => {
                                    this.setState({ openStatusDialog: true })
                                }}
                            >
                                <div style={{ paddingTop: 10 }}>
                                    <FontIcon className="fa fa-plus-circle" />
                                </div>
                            </IconButton>

                        </div>

                        <div style={{ gridColumn: 1, gridRow: "auto" }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.CoreStaff}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.CoreStaff = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Core Staff"}
                            />
                        </div>     

                        <div style={{ gridColumn: 2, gridRow: "auto", marginLeft: 10 }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.FloatStaff}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.FloatStaff = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Float Staff"}
                            />
                        </div> 

                        <div style={{ gridColumn: 1, gridRow: "auto" }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.PerDiemStaff}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.PerDiemStaff = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Per Diem Staff"}
                            />
                        </div>     

                        <div style={{ gridColumn: 2, gridRow: "auto", marginLeft: 10 }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.AgencyStaff}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.AgencyStaff = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Agency Staff"}
                            />
                        </div> 

                        <div style={{ gridColumn: 1, gridRow: "auto", marginTop: 10 }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.PreventBroadcastToEmployeesGoingIntoOvertime}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.PreventBroadcastToEmployeesGoingIntoOvertime = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Prevent Employees In Overtime"}
                            />
                        </div>

                        {!this.props.hideLimitBroadcastByProximityInMiles &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <Toggle
                                    toggled={this.state.gigPoolTierSettings.BroadcastFilterByMiles}
                                    onToggle={(event, value) => {
                                        this.state.gigPoolTierSettings.BroadcastFilterByMiles = value
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    labelPosition="left"
                                    label={"Limit Broadcast by Proximity in Miles"}
                                />
                            </div>
                        }

                        {!this.props.hideLimitBroadcastByProximityInMiles && this.state.gigPoolTierSettings.BroadcastFilterByMiles &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={"Miles to Job"}
                                    value={this.state.gigPoolTierSettings.BroadcastFilterByMilesValue}
                                    onChange={(e, value) => {
                                        this.state.gigPoolTierSettings.BroadcastFilterByMilesValue = value as number
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    type="number"
                                />
                            </div>
                        }

                        <div style={{ gridColumn: 1, gridRow: "auto" }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.BroadcastOnlyIfWorkerPoolIsEmpty}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.BroadcastOnlyIfWorkerPoolIsEmpty = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Broadcast Only If No Worker Pool Employees"}
                            />
                        </div>
                        <div style={{ gridColumn: 1, gridRow: "auto" }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.BroadcastByBadge}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.BroadcastByBadge = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Limit Broadcast by Badge"}
                            />
                        </div>

                        {this.state.gigPoolTierSettings.BroadcastByBadge &&
                            <div style={{ gridColumn: 1, gridRow: "auto", marginBottom: 20 }}>
                                <ChooseBadgeChip
                                    singleBadge={true}
                                    selectedBadges={this.state.gigPoolTierSettings.Badge ? [this.state.gigPoolTierSettings.Badge] : []}
                                    handleSave={badges => {
                                        if (badges) {
                                            this.state.gigPoolTierSettings.Badge = badges[0]
                                        } else {
                                            this.state.gigPoolTierSettings.Badge = null
                                        }

                                        this.setState({
                                            gigPoolTierSettings: this.state.gigPoolTierSettings
                                        })

                                    }}
                                    handleDelete={jobBadges => {
                                        this.state.gigPoolTierSettings.Badge = null

                                        this.setState({
                                            gigPoolTierSettings: this.state.gigPoolTierSettings
                                        })
                                    }} readonly={false}
                                />
                            </div>
                        }

                        {this.state.gigPoolTierSettings.BroadcastByBadge &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <Toggle
                                    toggled={this.state.gigPoolTierSettings.LimitBroadcastByBadgePoints}
                                    onToggle={(event, value) => {
                                        this.state.gigPoolTierSettings.LimitBroadcastByBadgePoints = value
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    labelPosition="left"
                                    label={"Limit and Rank Broadcast by Badge Points"}
                                />
                            </div>
                        }


                        {this.state.gigPoolTierSettings.LimitBroadcastByBadgePoints &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={"Employee Limit"}
                                    value={this.state.gigPoolTierSettings.LimitBroadcastByNumber}
                                    onChange={(e, value) => {
                                        this.state.gigPoolTierSettings.LimitBroadcastByNumber = value as number
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    type="number"
                                />
                            </div>
                        }

                        {this.props.title === "Tier 1" &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <Toggle
                                    toggled={this.state.gigPoolTierSettings.BroadcastOnSchedulePost}
                                    onToggle={(event, value) => {
                                        this.state.gigPoolTierSettings.BroadcastOnSchedulePost = value
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    labelPosition="left"
                                    label={"Broadcast On Schedule Post"}
                                />
                            </div>
                        }
                        {((this.props.title === "Tier 1" && !this.state.gigPoolTierSettings.BroadcastOnSchedulePost) || ["Tier 2", "Tier 3"].includes(this.props.title)) &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <Toggle
                                    toggled={this.state.gigPoolTierSettings.EnabledScheduledBroadcast}
                                    onToggle={(event, value) => {
                                        this.state.gigPoolTierSettings.EnabledScheduledBroadcast = value
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    labelPosition="left"
                                    label={"Scheduled Broadcast"}
                                />
                            </div>
                        }

                        {((this.props.title === "Tier 1" && !this.state.gigPoolTierSettings.BroadcastOnSchedulePost) || ["Tier 2", "Tier 3"].includes(this.props.title)) &&
                            this.state.gigPoolTierSettings.EnabledScheduledBroadcast &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={"Days To Trigger Broadcast"}
                                    value={this.state.gigPoolTierSettings.BraodcastAfterDaysFromPreviousTeir}
                                    onChange={(e, value) => {
                                        this.state.gigPoolTierSettings.BraodcastAfterDaysFromPreviousTeir = value as number
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    type="number"
                                />
                            </div>
                        }

                        {((this.props.title === "Tier 1" && !this.state.gigPoolTierSettings.BroadcastOnSchedulePost) || ["Tier 2", "Tier 3"].includes(this.props.title)) &&
                            this.state.gigPoolTierSettings.EnabledScheduledBroadcast &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={"Hours To Trigger Broadcast"}
                                    value={this.state.gigPoolTierSettings.BraodcastAfterHoursFromPreviousTeir}
                                    onChange={(e, value) => {
                                        this.state.gigPoolTierSettings.BraodcastAfterHoursFromPreviousTeir = value as number
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    type="number"
                                />
                            </div>
                        }

                        <div style={{ gridColumn: 1, gridRow: "auto" }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.RewardScheduledEmployee}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.RewardScheduledEmployee = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={"Reward Scheduled Employee"}
                            />
                        </div>               

                        {this.state.gigPoolTierSettings.RewardScheduledEmployee &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <SelectField value={this.state.rewardType}
                                    onChange={(e, i, value) => {
                                        this.state.gigPoolTierSettings.RewardScheduledEmployeeBadgePoints = false
                                        this.state.gigPoolTierSettings.RewardScheduledEmployeeAmount = false
                                        this.state.gigPoolTierSettings.RewardScheduledEmployeeDifferential = false

                                        switch (value) {
                                            case 0: {
                                                this.state.gigPoolTierSettings.RewardScheduledEmployeeBadgePoints = true
                                                break;
                                            } case 1: {
                                                this.state.gigPoolTierSettings.RewardScheduledEmployeeAmount = true
                                                break;
                                            } case 2: {
                                                this.state.gigPoolTierSettings.RewardScheduledEmployeeDifferential = true
                                                break;
                                            }
                                        }
                                        this.setState({ rewardType: this.getRewardTypeEnumValue(this.state.gigPoolTierSettings) })
                                    }}>
                                    <MenuItem value={-1} primaryText={"Choose Reward Type..."} />
                                    <MenuItem value={0} primaryText={"Badge Points"} />
                                    <MenuItem value={1} primaryText={"Flat Amount"} />
                                    <MenuItem value={2} primaryText={"Differential Pay"} />
                                </SelectField>
                            </div>
                        }

                        {this.state.gigPoolTierSettings.RewardScheduledEmployee && this.state.gigPoolTierSettings.RewardScheduledEmployeeBadgePoints &&
                            <div style={{ gridColumn: 1, gridRow: "auto", marginBottom: 20 }}>
                                <ChooseBadgeChip
                                    singleBadge={true}
                                    selectedBadges={this.state.gigPoolTierSettings.RewardsBadge ? [this.state.gigPoolTierSettings.RewardsBadge] : []}
                                    handleSave={badges => {
                                        if (badges) {
                                            this.state.gigPoolTierSettings.RewardsBadge = badges[0]
                                        } else {
                                            this.state.gigPoolTierSettings.RewardsBadge = null
                                        }

                                        this.setState({
                                            gigPoolTierSettings: this.state.gigPoolTierSettings
                                        })

                                    }}
                                    handleDelete={val => {
                                        this.state.gigPoolTierSettings.RewardsBadge = null
                                        this.setState({
                                            gigPoolTierSettings: this.state.gigPoolTierSettings
                                        })
                                    }} readonly={false}
                                />
                            </div>
                        }

                        {this.state.gigPoolTierSettings.RewardScheduledEmployee && this.state.gigPoolTierSettings.RewardScheduledEmployeeBadgePoints &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={"Points To Reward"}
                                    value={this.state.gigPoolTierSettings.RewardScheduledEmployeeBadgePointsValue}
                                    onChange={(e, value) => {
                                        this.state.gigPoolTierSettings.RewardScheduledEmployeeBadgePointsValue = value as number
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    type="number"
                                />
                            </div>
                        }

                        {this.state.gigPoolTierSettings.RewardScheduledEmployee && this.state.gigPoolTierSettings.RewardScheduledEmployeeAmount &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={"$ Amount To Reward"}
                                    value={this.state.gigPoolTierSettings.RewardScheduledEmployeeAmountValue}
                                    onChange={(e, value) => {
                                        this.state.gigPoolTierSettings.RewardScheduledEmployeeAmountValue = value as number
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    type="number"
                                />
                            </div>
                        }

                        {this.state.gigPoolTierSettings.RewardScheduledEmployee && this.state.gigPoolTierSettings.RewardScheduledEmployeeDifferential &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={"% Wage Differential Bonus Amount"}
                                    value={this.state.gigPoolTierSettings.RewardScheduledEmployeeDifferentialValue}
                                    onChange={(e, value) => {
                                        this.state.gigPoolTierSettings.RewardScheduledEmployeeDifferentialValue = value as number
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                    type="number"
                                />
                            </div>
                        }

                        {this.state.gigPoolTierSettings.RewardScheduledEmployee  &&
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <SelectField
                                    floatingLabelText={"Reward PayType"}
                                    value={this.state.gigPoolTierSettings.RewardPayTypeId}
                                    onChange={(event, key, payTypeId) => {
                                        this.state.gigPoolTierSettings.RewardPayTypeId = payTypeId
                                        this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                    }}
                                >
                                    {AccountStore.getCurrentAccount().PayTypes.filter(item => !item.Deleted).map(payType =>
                                        <MenuItem key={payType.Id} value={payType.Id} primaryText={payType.Name} />
                                    )}
                                </SelectField>
                            </div>
                        }

                        <div style={{ gridColumn: 1, gridRow: "auto", marginTop: 20 }}>
                            <Toggle
                                toggled={this.state.gigPoolTierSettings.AllowDiDiToCommunicateAndEncouragePickingUpShiftByCandidate}
                                onToggle={(event, value) => {
                                    this.state.gigPoolTierSettings.AllowDiDiToCommunicateAndEncouragePickingUpShiftByCandidate = value
                                    this.setState({ gigPoolTierSettings: this.state.gigPoolTierSettings })
                                }}
                                labelPosition="left"
                                label={
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                      <i className="fa-regular fa-sparkles" style={{ marginRight: 8 }} />
                                      Allow DiDi to Match Candidates For Shift
                                    </div>
                                  }
                            />                       
                        </div>

                        {this.state.gigPoolTierSettings && this.state.gigPoolTierSettings.AllowDiDiToCommunicateAndEncouragePickingUpShiftByCandidate && (
                            <div style={{ gridColumn: "span 2", gridRow: "auto" }}>
                                <TextField
                                    floatingLabelText={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="fa-regular fa-sparkles" style={{ marginRight: 8 }} />
        `                                 DiDi Prompt
                                        </div>
                                    }                                
                                    value={
                                        this.state.gigPoolTierSettings.DiDiPrompt ||
                                        "Be professional. Encourage the candidate to take a look at this shift and click on the shift link supplied in the text message to express interest in working. Be conversational and friendly. Use emojis, but don’t overdo it! Only contact the candidate a maximum of two times for this shift unless they respond with questions."
                                    }
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setState((prevState) => ({
                                        gigPoolTierSettings: {
                                            ...prevState.gigPoolTierSettings,
                                            DiDiPrompt: value,
                                        },
                                        }));
                                    }}
                                    multiLine={true}
                                    fullWidth={true}
                                    rows={2}
                                    variant="outlined" // You can change the variant if needed
                                />
                            </div>
                        )}                             
                    </div>
                }
                {this.state.openStatusDialog &&
                    <UserStatusDialog
                        open={this.state.openStatusDialog}
                        onClose={() => this.setState({ openStatusDialog: false })}
                        onStatusSelection={this.handleEmployeeStatusAdd}
                        statuses={this.state.employeeStatuses}
                    />
                }
            </Card>
        )
    }
}
